import { AxiosError } from "axios";
import type { Either } from "fp-ts/lib/Either";


export interface ErrorResponse {
  message: string;
  code?: string;
}

export type EitherErrorOrResponse<T> = Promise<Either<ErrorResponse, T>>;

const genericErrorResponse: ErrorResponse = {
  message: 'Failed to make request. Please try again.',
  code: 'UNKNOWN_ERROR',
};

export const handleAxiosError = (error: unknown): ErrorResponse => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as Partial<ErrorResponse> | undefined;
    if (data && typeof data.message === "string" && data.message.length > 0) {
      return { message: data.message, code: data.code };
    }
    return { ...genericErrorResponse, message: error.message || genericErrorResponse.message };
  }
  if (error instanceof Error && error.message) {
    return { ...genericErrorResponse, message: error.message };
  }
  return genericErrorResponse;
};
